import { render, staticRenderFns } from "./addAddress.vue?vue&type=template&id=3484d073&scoped=true"
import script from "./addAddress.vue?vue&type=script&lang=js"
export * from "./addAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3484d073",
  null
  
)

export default component.exports